export interface OrderListSearchVariables {
  orderCode?: string;
  customerSearch?: {
    customerFirstName?: string;
    customerLastName?: string;
    customerEmail?: string;
    customerPhone?: string;
  };
  productSearch?: { productName: string };
  trackingSearch?: { trackingCode: string };
}

/**
 * Maps the unified order-list search box to arguments supported by every
 * deployed version of ordersFiltered. The production schema does not expose
 * the newer searchTerm argument yet, so the dashboard must not reference it in
 * the GraphQL document (GraphQL rejects unknown arguments before execution).
 */
export function buildOrderListSearchVariables(search?: string): OrderListSearchVariables {
  const rawTerm = search?.trim() ?? '';
  if (!rawTerm) return {};

  const explicitOrderCode = rawTerm.startsWith('#');
  const term = rawTerm.replace(/^#/, '').trim();
  const phoneDigits = term.replace(/\D/g, '');
  const looksLikePhone = !explicitOrderCode && (
    term.startsWith('+')
    || /^0\d{8,}$/.test(term)
    || /^966\d{9}$/.test(term)
    || (/^[\d\s()-]+$/.test(term) && /[\s()-]/.test(term) && phoneDigits.length >= 7)
  );

  if (term.includes('@')) {
    return { customerSearch: { customerEmail: term } };
  }
  if (looksLikePhone) {
    return { customerSearch: { customerPhone: phoneDigits } };
  }
  if (explicitOrderCode || /^\d+$/.test(term)) {
    return { orderCode: term };
  }
  if (/^[A-Z0-9]+(?:-[A-Z0-9]+){2,}$/i.test(term) && term.length >= 8) {
    return { trackingSearch: { trackingCode: term } };
  }
  if (/^(?:sku:)?[A-Z0-9_-]*\d[A-Z0-9_-]*$/i.test(term)) {
    return { productSearch: { productName: term.replace(/^sku:/i, '') } };
  }

  return {
    customerSearch: {
      customerFirstName: term,
      customerLastName: term,
    },
  };
}
